import { Box, Flex, Image, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import { SocialMediaType, SocialsType } from '@/services/coin/social'

import CardFooter from './CardFooter'
import styles from './styles.module.css'

interface BaseCardProps {
  title: string
  description?: string
  thumbnail?: string
  source?: string
  pubDate: string
  type: SocialsType | SocialMediaType
  children?: React.ReactNode // For custom content like YoutubeVideo
  showDescription?: boolean
  link?: string // Add link prop for clickable functionality
}

export default function BaseCard({
  title,
  description,
  thumbnail,
  source,
  pubDate,
  type,
  children,
  showDescription = true,
  link,
}: BaseCardProps) {
  const t = useTranslations('newsCommunity')

  const handleClick = () => {
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <Flex
      direction="column"
      h={240}
      w={190}
      justify="space-between"
      className={styles.baseCardContainer}
      onClick={handleClick}
    >
      {/* Media section */}
      {(thumbnail || children) && (
        <Box className={styles.mediaSection}>
          {children || (
            <Image
              src={thumbnail}
              alt={t('newsCoverAlt')}
              height={80}
              fit="cover"
              className={styles.mediaImage}
            />
          )}
          {/* Gradient overlay */}
          <Box className={styles.gradientOverlay} />
        </Box>
      )}

      {/* Title section */}
      <Box mah={100} pt={thumbnail || children ? 0 : 16} pl={16} pr={16}>
        <Text variant="subtitle-emphasis" lineClamp={4}>
          {title}
        </Text>
      </Box>

      {/* Description section */}
      {showDescription && description && !thumbnail && !children && (
        <Box h={90} pl={16} pr={16}>
          <Text variant="subtitle" fz={11} lineClamp={4} c="var(--text-secondary)">
            {description}
          </Text>
        </Box>
      )}

      {/* Footer */}
      <CardFooter username={source || ''} create_time={pubDate} type={type} />
    </Flex>
  )
}
